import { makeAutoObservable, runInAction } from "mobx";
import {
  BookingData,
  BookingDetailsData,
  BookingStatus,
  PartnerPaymentData,
  PaymentData,
  ServiceSales,
} from "../../types/booking";
import { PaginationData, PagingParams } from "../../types/pagination";
import { ActionResult } from "../../types";
import agent from "../api/agent";
import { BookingSchema } from "../../lib/schemas/bookingSchema";
import {
  CanceledReason,
  convertEnumToString,
  formatDateTime,
  paymentType,
  RefundStatus,
} from "../../lib/utils";
import { DocumentBookingSchema } from "../../lib/schemas/documentBookingSchema";
import { KsaBookingFormSchema } from "../../lib/schemas/ksaBookingSchema";
import { ClientData } from "../../types/client";
import { RefundRequestFormData } from "../../lib/schemas/refundRequestSchema";
import { ResortBookingData, ResortBookingDetailsData } from "../../types/resortbooking";
import { ResortBookingSchema } from "../../lib/schemas/resortBookingSchema";

export default class ResortBookingStore {
  bookings: ResortBookingData[] | null | undefined = null;
  // bookingsForUber: BookingData[] | null | undefined = null;
  currentBooking: ResortBookingDetailsData | null = null;
  pagination: PaginationData | null = null;
  pagingParams = new PagingParams();
  loadingInitial = false;
  availableSlots: string[] | null = null;
  allBookings: ResortBookingData[] = []; // ✅ used for full reports without pagination
salesByService: ServiceSales[] = [];

  unavailableTimeSlots: UnavailableTimeSlot[] = [];
    loadingUnavailableDates = false;

  // New filter parameters
  searchTerm: string | null = null;
  bookingStatus: string | null = null;
  fromDate: string | null = null;
  toDate: string | null = null;
  serviceId: string | null = null;
  bookingCode: string | null = null;

invoiceNo: string | null = null;
  isSession: string[] | null = null;

  constructor() {
    makeAutoObservable(this);
  }


  
// calculateRemainingDays = async (
//   client: ClientData
// ): Promise<number | null> => {
//   if (!client.entryDateToUAE || !client.bookingId) return null;

//   try {
//     const booking = await this.getBooking(client.bookingId);
//     if (!booking || typeof booking.duration !== "number") return null;

//     const entryDate = new Date(client.entryDateToUAE);
//     const visaEndDate = new Date(entryDate);
//     visaEndDate.setDate(entryDate.getDate() + booking.duration);

//     const today = new Date();
//     const diffTime = visaEndDate.getTime() - today.getTime();
//     const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

//     return diffDays >= 0 ? diffDays : 0;
//   } catch (error) {
//     console.error("Error calculating remaining days:", error);
//     return null;
//   }
// };

  createRefundRequest = (refundRequest: RefundRequestFormData) => {
    return agent.Bookings.createRequest(refundRequest); // or however your agent is set up
  };


addPayment = (paymentData: PaymentData) => {
  return agent.Bookings.addPayment(paymentData); // or however your agent is set up
};




  // Add Booking
addBooking = async (
    booking: any
  ): Promise<ActionResult<string>> => {
    try {
      const response = await agent.ResortBookings.create(booking);
      runInAction(() => {
        this.bookings = this.bookings
          ? [...this.bookings, response]
          : [response];
      });

      const sessionId = this.getOrCreateSessionId();

      const storedSessionData = JSON.parse(
        localStorage.getItem(sessionId) || '{"value": []}'
      );
      const storedBookings: string[] = storedSessionData.value || [];

      if (!storedBookings.includes(response.id)) {
        storedBookings.push(response.id);
      }

      this.setSessionData(sessionId, storedBookings);

      return { status: "success", data: response.id };
    } catch (error: any) {
  console.error("Error adding booking:", {
    message: error.message,
    response: error.response?.data,
    status: error.response?.status,
  });

  return {
    status: "error",
    error: error.response?.data || error.message,
  };
}

  };



  setSessionData = (sessionId: string, data: string[]) => {
    const expiryTime = new Date().getTime() + 20 * 60 * 1000; // 20 minutes from now
    const sessionData = {
      value: data,
      expiry: expiryTime,
    };
    localStorage.setItem(sessionId, JSON.stringify(sessionData));
  };
  getOrCreateSessionId = (): string => {

  let sessionId = localStorage.getItem("sessionId");
  if (!sessionId) {
    sessionId = this.generateUniqueId();
    localStorage.setItem("sessionId", sessionId);
  }
  return sessionId;
};

getExistingSessionId = (): string | null => {
  return localStorage.getItem("sessionId");
};
getCurrentSessionBookings = (): string[] | null => {
  const sessionId = this.getExistingSessionId();
  if (!sessionId) return null;

  this.removeExpiredSessions(sessionId);

  const storedSessionData = localStorage.getItem(sessionId);
  if (storedSessionData) {
    const parsedSessionData = JSON.parse(storedSessionData);
    const currentSessionBookings = parsedSessionData.value;
    this.isSession = currentSessionBookings;
    Object.keys(localStorage)
    .filter((key) => key !== "sessionId" && key !== "language")
    .forEach((id) => this.removeExpiredSessions(id));

    return currentSessionBookings; // ✅ Important to return it
  }

  return null;
};

  getBooking = async (id: string) => {
    try {
      const result = await agent.ResortBookings.getById(id);

      runInAction(() => {
        this.currentBooking =result;
      });
      return this.currentBooking;
    } catch (error) {
      console.error("Error fetching booking: ", error);
      return null;
    }
  };


removeBookingSession = () => {
  const sessionId = this.getExistingSessionId();

  if (sessionId) {
    localStorage.removeItem(sessionId);
    localStorage.removeItem("sessionId");
  }

  this.isSession = null;
};




  removeExpiredSessions = (sessionId: string) => {
    const sessionData = localStorage.getItem(sessionId);
    if (sessionData) {
      const { expiry } = JSON.parse(sessionData);
      const currentTime = new Date().getTime();

      if (currentTime > expiry) {
        localStorage.removeItem(sessionId);
      }
    }
  };

  // Utility method to generate a unique ID (can use a library like UUID)
  generateUniqueId = (): string => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0,
        v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };

  getUnavailableDates = async (serviceId: string, startDate: Date, endDate: Date): Promise<UnavailableTimeSlot[]> => {
    this.loadingUnavailableDates = true;
    try {
      const result = await agent.ResortBookings.getUnavailableDates(serviceId, startDate, endDate);
      runInAction(() => {
        this.unavailableTimeSlots = result.unavailableTimeSlots || [];
      });
      return this.unavailableTimeSlots;
    } catch (error) {
      console.error("Error fetching unavailable dates:", error);
      throw error;
    } finally {
      this.loadingUnavailableDates = false;
    }
  };

  // Optional: Clear unavailable time slots when needed
  clearUnavailableTimeSlots = () => {
    this.unavailableTimeSlots = [];
  };
  // Delete Booking
  deleteBooking = async (id: string): Promise<ActionResult<string>> => {
    try {
      await agent.Bookings.delete(id);
      runInAction(() => {
        this.bookings = this.bookings?.filter((b) => b.id !== id) || null;
      });
      return { status: "success", data: "Booking deleted successfully" };
    } catch (error) {
      console.error("Error deleting booking: ", error);
      return { status: "error", error: error as string };
    }
  };

  // loadAllBookings = async () => {
  //   try {
  //     const response = await agent.Bookings.getAllWithoutPagination(); // Ensure this hits /booking/all
  //     runInAction(() => {
  //       this.allBookings = response; // This should be an array (not paginated)
  //     });
  //   } catch (error) {
  //     console.error("Failed to load all bookings", error);
  //   }
  // };




  // Get Booking by ID
  // getBooking = async (id: string) => {
  //   try {
  //     const result = await agent.Bookings.getById(id);

  //     runInAction(() => {
  //       this.currentBooking = {
  //         ...result,
  //         bookingStatus: convertEnumToString(
  //           Number(result.bookingStatus),
  //           BookingStatus
  //         ),
  //       };
  //     });
  //     return this.currentBooking;
  //   } catch (error) {
  //     console.error("Error fetching booking: ", error);
  //     return null;
  //   }
  // };


  // store/resortBookingStore.ts
getBookingsByServiceId = async (serviceId: string): Promise<ResortBookingData[]> => {
  try {
    const response = await agent.ResortBookings.listByServiceId(serviceId);

    runInAction(() => {
      this.bookings = response; // Cache if needed
    });

    return response;
  } catch (error) {
    console.error("Error fetching bookings by service ID", error);
    return [];
  }
};



  // Get Available Slots
  getAvailableSlots = async (date: string): Promise<ActionResult<string>> => {
    try {
      const result = await agent.Bookings.getAvailableSlots(date);
      runInAction(() => {
        this.availableSlots = result;
      });
      return {
        status: "success",
        data: "Received available slots successfully",
      };
    } catch (error) {
      runInAction(() => {
        this.availableSlots = null;
      });
      console.error("Error loading available slots: ", error);
      return { status: "error", error: error as string };
    }
  };

  // Update Booking Status
  setPaymentTypeOfBooking = async (
    id: string,
    type: paymentType
  ): Promise<ActionResult<string>> => {
    try {
      await agent.ResortBookings.setPaymentTypeOfBooking(id, type);
      await this.getBookingsByServiceId(id);
      return { status: "success", data: `Booking Payment Type set to ${type}` };
    } catch (error) {
      console.error("Error updating booking Payment Type: ", error);
      return { status: "error", error: error as string };
    }
  };

  setStatusInProcess = async (id: string): Promise<ActionResult<string>> => {
    try {
      await agent.ResortBookings.setStatusInProcess(id);
      await this.getBookingsByServiceId(id);
      return { status: "success", data: "Booking status set to 'In Process'." };
    } catch (error) {
      console.error("Error updating booking status: ", error);
      return { status: "error", error: error as string };
    }
  };

  setStatusCanceled = async (
    id: string,
    reason: CanceledReason
  ): Promise<ActionResult<string>> => {
    try {
      await agent.ResortBookings.setStatusCanceled(id, reason);
      await this.getBookingsByServiceId(id);
      return { status: "success", data: "Booking status set to 'Canceled'." };
    } catch (error) {
      console.error("Error updating booking status: ", error);
      return { status: "error", error: error as string };
    }
  };

  setStatusPending = async (id: string): Promise<ActionResult<string>> => {
    try {
      await agent.ResortBookings.setStatusPending(id);
      await this.getBookingsByServiceId(id);
      return { status: "success", data: "Booking status set to 'Canceled'." };
    } catch (error) {
      console.error("Error updating booking status: ", error);
      return { status: "error", error: error as string };
    }
  };

  setStatusCompleted = async (id: string): Promise<ActionResult<string>> => {
    try {
      await agent.ResortBookings.setStatusCompleted(id);
      await this.getBookingsByServiceId(id);
      return { status: "success", data: "Booking status set to 'Completed'." };
    } catch (error) {
      console.error("Error updating booking status: ", error);
      return { status: "error", error: error as string };
    }
  };

  // Set Pagination
  setPagination = (pagination: PaginationData) => {
    this.pagination = pagination;
  };

  // Axios Parameters with filters
  get axiosParams() {
    const params = new URLSearchParams();
    params.append("pageNumber", this.pagingParams.pageNumber.toString());
    params.append("pageSize", this.pagingParams.pageSize.toString());
    if (this.bookingStatus) params.append("bookingStatus", this.bookingStatus);
    if (this.fromDate) params.append("from", this.fromDate);
    if (this.toDate) params.append("to", this.toDate);
    if (this.serviceId) params.append("serviceId", this.serviceId);
    if (this.bookingCode) params.append("bookingCode", this.bookingCode);

        if (this.invoiceNo) params.append("invoiceNo", this.invoiceNo);
    if (this.searchTerm) params.append("searchTerm", this.searchTerm);
    return params;
  }


 setBookingCodeFilter = (bookingCode: string | null) => {
    this.bookingCode = bookingCode;
  };
 setInvoiceNoFilter = (invoiceNo: string | null) => {
    this.invoiceNo = invoiceNo;
  };


  // New methods to set filters
  setStatusFilter = (status: string | null) => {
    this.bookingStatus = status;
  };

  setDateFilter = (from: string | null, to: string | null) => {
    this.fromDate = from;
    this.toDate = to;
  };

  setServiceFilter = (serviceId: string | null) => {
    this.serviceId = serviceId;
  };

  setSearchTerm = (term: string) => {
    this.searchTerm = term;
  };

  clearBookings = () => {
    this.bookings = null;
  };

  setPagingParams = (pagingParams: PagingParams) => {
    this.pagingParams = pagingParams;
  };
}
